import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Toast } from "primereact";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { NumericFormat } from "react-number-format";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------------
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API--------------------------------
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { 
  EditarYarnCotton, 
  EliminarYarnDetail, 
  EliminarYarnDetail2, 
  getCalibres, 
  getEfectos, 
  getFibras, 
  getTypes, 
  getTypesCotton, 
  getYarn, 
  getYarnDetailsPorID, 
  GuardarYarnCotton, 
  ObtenerSiguienteCorrelativoC 
} from "../../../API/Desarrollo/DesarrolloRequest";

const YarnCottonCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected,
  modo,
  getInfo,
}) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [types, setTypes] = useState([]);
  const [efectos, setEfectos] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const [calibres, setCalibres] = useState([]);
  const [fibras, setFibras] = useState([]);
  const [typesCotton, setTypesCotton] = useState([]);
  const [titulo, setTitulo] = useState(null);
  const [button, setButton] = useState(null);

  const initialValues = {
    IdYarnTitle: -1,
    IdStatus: selected ? selected?.IdStatus : 3706,
    Yarn: "",
  };

  const ply = [
    { IdPlay: 1, Play: "1" },
    { IdPlay: 2, Play: "2" },
  ];

  const origen = [
    { IdOrigin: 1, Origin: "CAFTA" },
    { IdOrigin: 2, Origin: "NO CAFTA" },
  ];

  const { values, handleInputChange, handleChange, setValues, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory('Yarn');
    setEstados(estadosTempo);
    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    const calibresTempo = await getCalibres();
    setCalibres(calibresTempo);

    const calibreInicial = modo === "Crear" ? calibresTempo : calibresTempo.find((e) => e.IdCalibre === selected?.IdCalibre);

    const typesTempo = await getTypes();
    setTypes(typesTempo);

    const typeInicial = modo === "Crear" ? typesTempo : typesTempo.find((e) => e.IdType === selected?.IdType);

    const efectosTempo = await getEfectos();
    setEfectos(efectosTempo);

    const efectoInicial = modo === "Crear" ? efectosTempo : efectosTempo.find((e) => e.IdEfecto === selected?.IdEfecto);

    const typesCottonTempo = await getTypesCotton();
    setTypesCotton(typesCottonTempo);

    const fibrasTempo = await getFibras();
    setFibras(fibrasTempo);

    const resp = await ObtenerSiguienteCorrelativoC();
    const corretativo = modo === "Crear" ? resp[0]?.Correlativo : selected?.Correlativo;

    setValues({
      ...selected,
      IdYarnTitle: selected ? selected?.IdYarnTitle : -1,
      Correlativo: corretativo,
      Estado: estadoInicial,
      IdStatus: estadoInicial?.IdStatus,
      Calibre: calibreInicial?.Calibre,
      IdCalibre: calibreInicial?.IdCalibre,
      Type: typeInicial?.Type,
      IdType: typeInicial?.IdType,
      Efecto: efectoInicial?.Efecto,
      IdEfecto: efectoInicial?.IdEfecto
    });

    if (selected?.IdYarnTitle > 0) {
      const detallesTempo = await getYarnDetailsPorID(selected?.IdYarnTitle);
      setDetalles(detallesTempo);
    } else {
      setDetalles([]);
    }

    setLoading(false);
  };

  const obtenerInformacion = async (IdYarnTitle) => {
    setLoading(true);

    const encTempo = await getYarn();
    setTitulo("Editar Yarn Cotton");

    let encabezadoTempo = encTempo?.filter((i) => i.IdYarnTitle === IdYarnTitle);

    setValues({
      ...encabezadoTempo,
      IdYarnTitle: encabezadoTempo[0]?.IdYarnTitle,
      Calibre: encabezadoTempo[0]?.Calibre,
      IdCalibre: encabezadoTempo[0]?.IdCalibre,
      Play: encabezadoTempo[0]?.Play,
      IdType: encabezadoTempo[0]?.IdType,
      Type: encabezadoTempo[0]?.Type,
      IdOrigin: encabezadoTempo[0]?.IdOrigin,
      Origin: encabezadoTempo[0]?.Origin,
      Efecto: encabezadoTempo[0]?.Efecto,
      IdEfecto: encabezadoTempo[0]?.IdEfecto,
      Yarn: encabezadoTempo[0].Yarn,
    });

    const detallesTempo = await getYarnDetailsPorID(IdYarnTitle);
    setDetalles(detallesTempo);

    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};

    if (modo === "Crear") {
      if (!values?.IdCalibre && !values?.Calibre?.IdCalibre) {
        error.IdCalibre = true;
        error.error = true;
      }
      if (!values?.IdPlay && !values?.Play?.IdPlay) {
        error.IdPlay = true;
        error.error = true;
      }
      if (!values?.IdType && !values?.Type?.IdType) {
        error.IdType = true;
        error.error = true;
      }
      if (!values?.IdOrigin && !values?.Origin?.IdOrigin) {
        error.IdOrigin = true;
        error.error = true;
      }
    } else {
      if (!values?.Calibre || !values?.IdCalibre) {
        error.IdCalibre = true;
        error.error = true;
      }
      if (!values?.Play) {
        error.IdPlay = true;
        error.error = true;
      }
      if (!values?.Type || !values?.IdType) {
        error.IdType = true;
        error.error = true;
      }
      if (!values?.Origin || !values?.IdOrigin) {
        error.IdOrigin = true;
        error.error = true;
      }
    }

    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e?.error) {
      if (detalles?.length <= 0) {
        toastShow(toast, "error", "Error", "Agregue al menos una composición.");
        return;
      }

      const tienePorcentajeInvalido = detalles.some((detalle) => detalle?.Porcentaje === null || detalle?.Porcentaje === 0);
      const tieneFibraInvalida = detalles.some((detalle) => detalle?.IdFibra === null );
      const tieneTypeInvalida = detalles.some((detalle) => detalle?.IdTypeCotton === null );
      const sumaPorcentajes = detalles.reduce((acc, detalle) => acc + (detalle?.Porcentaje || 0), 0 );

      if (tienePorcentajeInvalido) {
        toastShow(
          toast,
          "error",
          "Error",
          "Todos los detalles deben tener un porcentaje válido."
        );
        return;
      }

      if (tieneFibraInvalida) {
        toastShow(
          toast,
          "error",
          "Error",
          "Todos los detalles deben tener una Fibra."
        );
        return;
      }

      if (sumaPorcentajes !== 100) {
        toastShow(
          toast,
          "error",
          "Error",
          "La suma de los porcentajes debe ser 100%."
        );
        return;
      }

      const tieneFibraUno = detalles.some((detalle) => detalle?.IdFibra === 1 || detalle?.IdFibra === 3);
      if (!tieneFibraUno) {
        toastShow(
          toast,
          "error",
          "Error",
          "Debe haber al menos un detalle con Fibra Algodón."
        );
        return;
      }

      // Validación de duplicados (IdType e IdFibra deben ser únicos)
      const combinaciones = new Set();
      for (const detalle of detalles) {
        const key = `${detalle.IdTypeCotton || detalle.IdType}-${detalle.IdFibra}`;
        if (combinaciones.has(key)) {
          toastShow(
            toast,
            "error",
            "Error",
            "Cada composición debe ser única."
          );
          return;
        }
        combinaciones.add(key);
      }

      const DatosEncabezado = {
        IdYarnTitle: values?.IdYarnTitle,
        Yarn: values?.Yarn,
        IdCalibre: values?.Calibre?.IdCalibre || values?.IdCalibre,
        Play: values?.Play?.IdPlay || values?.Play,
        IdType: values?.Type?.IdType || values?.IdType,
        IdOrigin: values?.Origin?.IdOrigin || values?.IdOrigin,
        Origin: values?.Origin?.Origin || values?.Origin,
        IdEfecto: values?.Efecto?.IdEfecto || values?.IdEfecto,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      const DatosDetalle = detalles.map((detalle) => ({
        ...detalle[0],
        IdYarnDetails: detalle?.IdYarnDetails,
        IdYarnTitle: values?.IdYarnTitle,
        Porcentaje: detalle?.Porcentaje,
        IdFibra: detalle?.IdFibra,
        IdType: detalle?.IdType || detalle?.IdTypeCotton,
        Description: detalle?.Description,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      }));


      console.log(DatosEncabezado)
      console.log(DatosDetalle)

      setLoading(true);

      if (DatosEncabezado?.IdYarnTitle > 0) {
        const resp = await EditarYarnCotton(DatosEncabezado, DatosDetalle);
        if (resp[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", resp[0].MENSAJE);
          setTimeout(() => {
            // onHide();
            obtenerInformacion(resp[0]?.IdYarnTitle);
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", resp[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const resp = await GuardarYarnCotton(DatosEncabezado, DatosDetalle);
        if (resp[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", resp[0].MENSAJE);
          setTimeout(() => {
            // onHide();
            obtenerInformacion(resp[0]?.IdYarnTitle);
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", resp[0].MENSAJE);
          setLoading(false);
        }
      }
    } else {
      toastShow(toast, "error", "Error", "Complete los campos requeridos.");
    }
  };

  const agregarDetails = () => {
    const e = verificarInfo();
    // if (!e?.error) {
    //   if (detalles?.length >= 3) {
    //     toastShow(toast, "error", "Error", "Solo se permiten 3 composiciones.");
    //     return;
    //   }

    //   let newRowData = [...detalles];
    //   let IdDet;

    //   do {
    //     IdDet = Math.floor(-(detalles.length + 1) * Math.random() * 1000);
    //   } while (newRowData.some((detalle) => detalle.IdYarnDetails === IdDet));

    //   const newData = {
    //     IdYarnDetails: IdDet,
    //     DateCreate: new Date(),
    //     Porcentaje: 0,
    //     IdFibra: null,
    //     Fiber: "",
    //     IdTypeCotton: null,
    //     TypeCotton: "",
    //     Description: "",
    //     IdStatus: 66,
    //     StatusName: "Activo",
    //   };
    //   newRowData.push(newData);
    //   setDetalles(newRowData);
    // } else {
    //   toastShow(toast, "error", "Error", "Complete los campos requeridos.");
    // }
    if (detalles?.length >= 3) {
      toastShow(toast, "error", "Error", "Solo se permiten 3 composiciones.");
      return;
    }

    let newRowData = [...detalles];
    let IdDet;

    do {
      IdDet = Math.floor(-(detalles.length + 1) * Math.random() * 1000);
    } while (newRowData.some((detalle) => detalle.IdYarnDetails === IdDet));

    const newData = {
      IdYarnDetails: IdDet,
      DateCreate: new Date(),
      Porcentaje: 0,
      IdFibra: null,
      Fiber: "",
      IdTypeCotton: null,
      TypeCotton: "",
      Description: "",
      IdStatus: 66,
      StatusName: "Activo",
    };
    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const calcularCantidad = (value, datosD, columna) => {
    let valor = value === undefined ? 0 : value;
    let detalle;

    handleChange(valor, "Porcentaje");
    detalle = datosD.data;
    detalle.Porcentaje = valor;

    let tempo = detalles;
    const index = tempo.findIndex(
      (detail) => detail?.IdYarnDetails === detalle?.IdYarnDetails
    );
    tempo[index] = detalle;
    construirYarnText();
  };

  const InputPorcentaje = ({ datosD }) => {
    return (
      <div>
        <NumericFormat
          value={datosD.data.Porcentaje}
          onValueChange={(values) =>
            calcularCantidad(values.floatValue, datosD, 6)
          }
          allowLeadingZeros
          thousandSeparator=","
          isAllowed={(values) =>
            values.floatValue === undefined || values.floatValue <= 100
          } 
        />
      </div>
    );
  };

  const changeDescription = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail?.IdYarnDetails === data?.IdYarnDetails);
    let newDetail = [...detalles];
    if (column.field === "Description") {
      newDetail[index].Description = data.Description;
    }
    setDetalles(newDetail);
  };

  const eliminarComposicion = async (rowData) => {
    if (rowData?.IdYarnDetails < 0) {
      setLoading(true);
      setDetalles((prevDetalles) => prevDetalles.filter((detalle) => detalle.IdYarnDetails !== rowData.IdYarnDetails));
      setLoading(false);
    } else {
      setLoading(true);

      confirmDialog({
        message: "Esta seguro que desea eliminar",
        header: "Eliminar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: async () => {
          let porcentajeAEliminar = rowData?.Porcentaje;
          const sumaPorcentajes = detalles.reduce((acc, detalle) => acc + detalle.Porcentaje, 0);
          let nuevoPorcentaje = sumaPorcentajes - porcentajeAEliminar;

          let detallesSinRowData = detalles.filter((detalle) => detalle.IdYarnDetails !== rowData.IdYarnDetails);

          const DatosEncabezado = {
            IdYarnTitle: values?.IdYarnTitle,
            Yarn: values?.Yarn,
            IdCalibre: values?.IdCalibre || values?.Calibre?.IdCalibre,
            Play: values?.Play?.Play || values?.Play,
            IdType: values?.IdType || values?.Type?.IdType,
            IdOrigin: values?.IdOrigin || values?.Origin?.IdOrigin,
            Origin: values?.Origin?.Origin || values?.Origin,
            IdEfecto: values?.Efecto?.IdEfecto || values?.IdEfecto,
            IdUserCreate: userAuth?.IdUser,
            IdUserEdit: userAuth?.IdUser,
          };

          let resp;
          if (nuevoPorcentaje !== 100) {
            resp = await EliminarYarnDetail(rowData);
            getValoresIniciales();
            construirYarnText();
          } else {
            resp = await EliminarYarnDetail2(rowData);
            getValoresIniciales();
            construirYarnText();
            const a = await EditarYarnCotton( DatosEncabezado, detallesSinRowData);
          }
          if (resp[0]?.ESTADO === 1) {
            toastShow(toast, "success", "Eliminado", "Composicion Eliminada.");
            getInfo();
            if (nuevoPorcentaje !== 100) {
              toastShow(
                toast,
                "warn",
                "Advertencia",
                "Actualmente el Hilo queda inactivo, hasta que agregue el 100% de la composición."
              );
            }
          } else {
            toastShow(toast, "error", "Error", "Error al eliminar Detalle");
          }
        },
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });

      setLoading(false);
    }
  };

  const construirYarnText = () => {
    let Calibre = values?.Calibre?.Calibre || values?.Calibre || "";
    let Play = values?.Play?.Play || values?.Play || "";
    Play = Play ? `/${Play}` : "";
    let Type = values?.Type?.Type || values?.Type || "";
    let Origin

    // let Origin = values?.Origin?.IdOrigin === 1 || values?.IdOrigin === 1 ? "01"
    // : values?.Origin?.IdOrigin === 2 || values?.IdOrigin === 2 ? "02" : "";
    // console.log(values?.Origin?.IdOrigin)

    if(values?.Origin?.IdOrigin === 1){
      Origin = '01'
    }else{
      if(values?.IdOrigin === 1 && !values?.Origin?.IdOrigin){
        Origin = '01'
      }else{
        Origin = '02'
      }
    }

    let Efecto = values?.Efecto?.Efecto || values?.Efecto || "";

    // console.log(Origin)

    // Ordenar por prioridad: Cotton (1), Rayon (3), Poly (2)
    let detallesOrdenados = [...detalles].sort((a, b) => {
      const prioridad = { 1: 1, 3: 2, 2: 3 }; // Definiendo prioridades
      return (
        prioridad[a.IdFibra] - prioridad[b.IdFibra] ||
        b.Porcentaje - a.Porcentaje
      );
    });

    let fibrasTexto = [];
    let porcentajeCotton = 0,
      porcentajePoly = 0,
      porcentajeRayon = 0;

    detallesOrdenados.forEach((detalle) => {
      let tipo = "";
      if (detalle?.IdFibra === 1) {
        tipo = detalle?.Fiber;
        porcentajeCotton += detalle.Porcentaje;
      } else if (detalle?.IdFibra === 3) {
        tipo = detalle?.Fiber;
        porcentajeRayon += detalle?.Porcentaje;
      } else if (detalle?.IdFibra === 2) {
        tipo = detalle?.Fiber;
        porcentajePoly += detalle.Porcentaje;
      }

      fibrasTexto.push(
        `${detalle.Porcentaje}% ${tipo} ${detalle.TypeCotton || ""}`.trim()
      );
    });

    let sumaCot = porcentajeCotton + porcentajeRayon;
    let valor = "";
    if (porcentajeCotton > 0 && porcentajePoly > 0) {
      valor = sumaCot >= porcentajePoly ? "CVC" : "CVS";
    }

    let yarnText = [
      `${Calibre}${Play}`,
      Type,
      valor,
      ...fibrasTexto,
      Efecto,
      Origin,
    ]
      .filter(Boolean)
      .join(" ");

    yarnText = yarnText
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    setValues({
      ...values,
      Yarn: yarnText.trim(),
    });
  };

  const duplicarCotizacion = async (encabezado, detalles) => {
    if (encabezado?.IdYarnTitle > 0) {
      setLoading(true);
      const resp = await ObtenerSiguienteCorrelativoC();

      setValues({
        ...values,
        IdYarnTitle: -1,
        Correlativo: resp[0]?.Correlativo,
        Play: encabezado?.Play,
        IdPlay: encabezado?.Play
      });

      const nuevosDetalles = detalles.map((det) => ({
        ...det,
        IdYarnDetails: det?.IdYarnDetails * -1,
      }));
      setTitulo("Agregar Yarn Cotton");
      setButton("Guardar");

      setTimeout(() => {
        setDetalles(nuevosDetalles);
        toastShow(toast, "success", "Nuevo", "Información duplicada.");
        setLoading(false);
      }, 700);
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        "Guarde la cotización antes de duplicarla."
      );
    }
  };

  const colums = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdYarnDetails",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth?.IdRol === 1,
    },
    {
      field: "DateCreate",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
      Sumary: "count",
    },
    {
      field: "Porcentaje",
      header: "%",
      headerEn: "%",
      Format: "Porcentaje",
      cellEditor: (data) => <InputPorcentaje datosD={data} />,
      editable: true,
      className: "Xsmall",
      Sumary: "sum",
    },
    {
      header: "Fibra",
      headerEn: "Fiber",
      field: "Fiber",
      className: "medium",
      Format: "AutoComplete",
      items: fibras,
      editable: true,
      value: "IdFibra",
      label: "Fiber",
      onChange: ({
        state,
        data: rowData,
        value,
        label,
        api,
        items,
        oldValue,
      }) => {
        let row = { ...rowData };
        let tempo = [...detalles];
        if (state?.IdFibra !== oldValue?.IdFibra) {
          if (row.IdYarnDetails) {
            row.IdFibra = state?.IdFibra;
            row.Fiber = state?.Fiber;
            const index = detalles.findIndex((d) => d.IdYarnDetails === row.IdYarnDetails);
            tempo[index] = row;
          }
        }else{
          return
        }
        setTypesCotton(typesCotton)
        setDetalles(tempo)
      }
    },
    {
      header: "Tipo",
      headerEn: "Type",
      field: "TypeCotton",
      className: "medium",
      Format: "AutoComplete",
      items: typesCotton,
      editable: ({data}) =>{
        if(data.IdFibra)
          return true
      },
      value: "IdTypeCotton",
      label: "TypeCotton",
      onChange: ({
        state,
        data: rowData,
        value,
        label,
        api,
        items,
        oldValue,
      }) => {
        let row = { ...rowData };
        let tempo = [...detalles];
        if (state?.IdTypeCotton !== oldValue?.IdTypeCotton) {
          if (row.IdYarnDetails) {
            row.IdTypeCotton = state?.IdTypeCotton;
            row.TypeCotton = state?.TypeCotton;
            const index = detalles.findIndex((d) => d.IdYarnDetails === row.IdYarnDetails);
            tempo[index] = row;
          }
        }else{
          return
        }
        setDetalles(tempo)
      },
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "Description",
      className: "medium",
      flex: 1,
      onChange: (data) => changeDescription(data),
      editable: true,
      minWidth: 200,
    },
    {
      field: "IdYarnDetails",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-trash",
          tooltip: "Eliminar",
          onClick: (rowData) => {
            if (rowData?.IdYarnDetails) {
              eliminarComposicion(rowData);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: detalles,
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={ button ? button : modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);

  useEffect(() => {
    if (detalles.length > 0) {
      construirYarnText();
    } else {
      let Calibre = values?.Calibre?.Calibre || values?.Calibre || '';
      let Play = values?.Play?.Play || values?.Play || '';
      Play = '/' + Play
      let Type = values?.Type?.Type || values?.Type || '';
      if (values?.Calibre?.Calibre || values?.Calibre) {
        setValues({
          ...values,
          Yarn: Calibre + Play + ' ' + Type
        });
      }
    }
  }, [detalles, values?.Efecto, values?.Origin?.IdOrigin, values?.Type?.Type, values?.Calibre?.IdCalibre, values?.Play?.Play]);

  const dialogTitle = modo === "Crear" ? `${getLabel(baseLang, "Agregar Yarn Cotton", config.language)}` : `${getLabel(baseLang, "Editar Yarn Cotton", config.language)}`;

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        style={{ width: "65%" }}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-2">
              <h3 className="me-3">{titulo ? titulo : dialogTitle}</h3>
              {values?.Correlativo && (
                <h2>
                  <strong>{values?.Correlativo}</strong>
                </h2>
              )}
            </div>

            <div className="d-flex gap-2 mx-2">
              <div className="field mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Calibre"}
                    value={values.Calibre}
                    items={calibres}
                    field={"Calibre"}
                    label={getLabel(baseLang, "Calibre", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdCalibre ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Play"}
                    value={values.Play}
                    items={ply}
                    field={"Play"}
                    label={getLabel(baseLang, "Ply", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdPlay ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Type"}
                    value={values.Type}
                    items={types}
                    field={"Type"}
                    label={getLabel(baseLang, "Spinnig", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdType ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Efecto"}
                    value={values.Efecto}
                    items={efectos}
                    field={"Efecto"}
                    label={getLabel(baseLang, "Efecto", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdEfecto ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Origin"}
                    value={values.Origin}
                    items={origen}
                    field={"Origin"}
                    label={getLabel(baseLang, "Origin", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdOrigin ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field mt-2">
                <Button
                  icon="pi pi-plus"
                  tooltip="Agregar Composición"
                  onClick={() => agregarDetails()}
                />
              </div>
              <div className="field mt-2">
                <Button
                  icon="pi pi-copy"
                  type="button"
                  disabled={values?.IdYarnTitle <= 0}
                  onClick={() => duplicarCotizacion(values, detalles)}
                  tooltip="Duplicar"
                  style={{ marginLeft: 1, zIndex: 999999 }}
                />
              </div>
            </div>

            <div className="d-flex gap-2 mx-2 mt-4">
              <div className="field mt-2" style={{ width: "100%" }}>
                <span className="p-float-label">
                  <InputText
                    name="Yarn"
                    value={values.Yarn}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    disabled
                  />
                  <label htmlFor="Yarn">
                    {getLabel(baseLang, "Yarn", config.language)}
                  </label>
                </span>
              </div>
            </div>

            <div className="mt-4 mx-2" style={{ height: "30vh" }}>
              <AgGrid table={table} />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default YarnCottonCRUD;
